var React = require('react');

function CheckboxCheckedInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1","width":"21","height":"21","rx":"5","stroke":"#0A9E50","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M6 13L9 16L17 8","stroke":"#0A9E50","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckboxCheckedInline.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = CheckboxCheckedInline;

CheckboxCheckedInline.default = CheckboxCheckedInline;
